import { render, staticRenderFns } from "./AccountingConfigEdit.vue?vue&type=template&id=488b7e91&"
import script from "./AccountingConfigEdit.vue?vue&type=script&lang=js&"
export * from "./AccountingConfigEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports